import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { XpressDisciplinaryService, AppDataService } from 'app/services';
import {
    XpressDisciplinaryStatus, XpressDisciplinaryActionEnum, XpressDisciplinaryPeriodEnum,
    XpressDisciplinaryActionModel, XpressDisciplinaryPeriodModel
} from 'app/models';
import { HomeDisciplinaryComponent } from 'app/home';
import { Utils } from 'app/utils';
import moment from 'moment';
import { cl } from '@fullcalendar/core/internal-common';

enum MenuTab {
    Details = 1,
    Investigation = 2,
    Hearing = 3,
    Disciplinary = 4
}

@Component({
    selector: 'disciplinary-investigation',
    templateUrl: './disciplinary-investigation.component.html',
    styleUrls: ['./disciplinary-investigation.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class DisciplinaryInvestigationComponent implements OnInit {
    public disciplinaryId: number = 0;
    @Input()
    set _disciplinaryId(value: number) {
        this.disciplinaryId = value;
    }

    @Input() public showDisciplinaryInvestigationSideBar: boolean = false;

    @Input() public homeDisciplinaryComponent!: HomeDisciplinaryComponent;

    constructor(private messageService: MessageService, private disciplinaryService: XpressDisciplinaryService,
        public appData: AppDataService) {
    }

    @Output() changedShowDisciplinaryInvestigationSideBarEmit = new EventEmitter<boolean>();
    changedShowDisciplinaryInvestigationSideBar(increased: any) {
        this.changedShowDisciplinaryInvestigationSideBarEmit.emit(increased);
    }

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.Details;

    public loading: boolean = false;
	public disciplinary: any = {};

    public displayModalInvestigation: boolean = false;

    public disciplinaryActionEnum = XpressDisciplinaryActionEnum;

    public disciplinaryActions = XpressDisciplinaryActionModel.XpressDisciplinaryActionList;
    public disciplinaryPeriodList = XpressDisciplinaryPeriodModel.XpressDisciplinaryPeriodList;

    public displayModalAddHearingOrReason: boolean = false;
    public hearingOrReasonTitle!: string;
    public hearingOrReasonDescription!: string;

    public disableBtnNoShowAndStartHearing: boolean = true;

    public displayModalNoShow: boolean = false;
    public showHearingReport: boolean = false;

    ngOnInit(): void {
        this.getDetailDisciplinary();
    }

    public handleTabChange(tab: MenuTab) {
        this.activeMenuTab = tab;
    }

    public getDetailDisciplinary() {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.disciplinaryService.getDetailDisciplinary(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.disciplinary = data;
                this.disciplinary.CreatedAt = moment(this.disciplinary.CreatedAt).format('DD MMMM YYYY');
                this.disciplinary.OffenseDateTime = moment(this.disciplinary.CreatedAt).format('DD MMMM YYYY');
                if (this.disciplinary.ComplaintMemberSince) {
                    this.disciplinary.ComplaintMemberSince = moment(this.disciplinary.ComplaintMemberSince).format('DD MMMM YYYY');
                }
                if (moment(this.disciplinary.HearingDateTime).format('YYYY-MM-DDThh:mm') <= moment(new Date()).format('YYYY-MM-DDThh:mm')) {
                    this.disableBtnNoShowAndStartHearing = false;
                }
                if (this.disciplinary.HearingDateTime) {
                    this.disciplinary.HearingDate = moment(this.disciplinary.HearingDateTime).format('DD MMMM YYYY');
                    this.disciplinary.HearingTime = moment(this.disciplinary.HearingDateTime).format('hh:mm');
                }
                if (this.disciplinary.InvestigationStartedAt) {
                    this.disciplinary.InvestigationStartedAt = moment(this.disciplinary.InvestigationStartedAt).format('DD MMMM YYYY');
                }
                if (this.disciplinary.InvestigationFinishedAt) {
                    this.disciplinary.InvestigationFinishedAt = moment(this.disciplinary.InvestigationFinishedAt).format('DD MMMM YYYY');
                }
                switch (this.disciplinary.DisciplinaryStatusId) {
                    case XpressDisciplinaryStatus.Suspension: {
                        this.disciplinary.StatusColor = '#F77F00';
                        this.disciplinary.StatusBackColor = '#FFEFCC';
                        break;
                    }
                    case XpressDisciplinaryStatus.New: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#0A84FF';
                        break;
                    }
                    case XpressDisciplinaryStatus.Pending: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#818181';
                        this.activeMenuTab = MenuTab.Disciplinary;
                        break;
                    }
                    case XpressDisciplinaryStatus.Hearing: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#00C0F0';
                        this.activeMenuTab = MenuTab.Hearing;
                        break;
                    }
                    case XpressDisciplinaryStatus.Investigating: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#004060';
                        this.activeMenuTab = MenuTab.Investigation;
                        break;
                    }
                    case XpressDisciplinaryStatus.Meeting: {
                        this.disciplinary.StatusColor = '#004060';
                        this.disciplinary.StatusBackColor = '#CCD9DF';
                        break;
                    }
                    case XpressDisciplinaryStatus.Cleared: {
                        this.disciplinary.StatusColor = '#004060';
                        this.disciplinary.StatusBackColor = '#BAC5CB';
                        break;
                    }
                    case XpressDisciplinaryStatus.Banned: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#EB4236';
                        break;
                    }
                    case XpressDisciplinaryStatus.Closed: {
                        this.disciplinary.StatusColor = '#004060';
                        this.disciplinary.StatusBackColor = '#BAC5CB';
                        break;
                    }
                }
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    public cancelOrOpenModalInvestigation() {
        this.displayModalInvestigation = !this.displayModalInvestigation;
    }
    public setInvestigativeUserAndSetStatusInvestigation() {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId,
            InvestigationUserId: this.appData.authData.UserId
        };
        this.disciplinaryService.setInvestigativeUserAndSetStatusInvestigation(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.displayModalInvestigation = false;
                this.activeMenuTab = MenuTab.Investigation;
                this.loading = false;
                this.getDetailDisciplinary();
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    public saveOrSubmitInvestigation(object: any) {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId,
            InvestigationReport: this.disciplinary.InvestigationReport,
            DisciplinaryActionId: this.disciplinary.DisciplinaryActionId,
            ReasonId: object.reasonId,
            Reason: object.reason,
            InvestigationAttachmentReports: this.disciplinary.InvestigationAttachmentReports
        };
        this.disciplinaryService.saveInvestigationAndSetStatusPending(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.getDetailDisciplinary();
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    public saveInvestigationAndSetStatusHearing(object: any) {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId,
            InvestigationReport: this.disciplinary.InvestigationReport,
            DisciplinaryActionId: this.disciplinary.DisciplinaryActionId,
            HearingLocationId: object.hearingLocationId,
            HearingDateTime: object.hearingDateTime,
            InvestigationAttachmentReports: this.disciplinary.InvestigationAttachmentReports
        };
        this.disciplinaryService.saveInvestigationAndSetStatusHearing(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.getDetailDisciplinary();
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    public openDisplayModalAddHearingOrReasonSideBar() {
        if (this.disciplinary.DisciplinaryActionId === XpressDisciplinaryActionEnum.Closed) {
            this.hearingOrReasonTitle = 'Close Investigation';
            this.hearingOrReasonDescription = `Closing the investigation will result in no sanctions being taken against the driver and this case will be closed. 
            Please provide the reason for this by selecting from the drop down below:`;
        }
        else if (this.disciplinary.DisciplinaryActionId === XpressDisciplinaryActionEnum.Suspension) {
            this.hearingOrReasonTitle = 'Suspension';
            this.hearingOrReasonDescription = `Suspending the driver will result in immediate suspension for the driver (if the driver is on an active trip it will take 
                effect upon completion). Before the driver can be suspended, a hearing must be conducted so the driver can present their case. Please set the time below`;
        }
        else if (this.disciplinary.DisciplinaryActionId === XpressDisciplinaryActionEnum.Ban) {
            this.hearingOrReasonTitle = 'Banned';
            this.hearingOrReasonDescription = `Banning the driver will result in immediate suspension for the driver (if the driver is on an active trip it will take 
                effect upon completion). Before the driver can be banned, a hearing must be conducted so the driver can present their case. Please set the time below`;
        }
        else if (this.disciplinary.DisciplinaryActionId === XpressDisciplinaryActionEnum.TemporarySuspended) {
            this.messageService.add({
                severity: 'error', summary: 'Error',
                detail: 'Please select Investigation Recommendation. Temporary Suspended should not be selected.'
            });
            return;
        }
        this.displayModalAddHearingOrReason = true;
    }
    changedDisplayModalAddHearingOrReasonEmit(value: any) {
        if (value.data) {
            if (value.data.hearingLocationId && value.data.hearingDateTime) {
                this.saveInvestigationAndSetStatusHearing(value.data);
            }
            else if (value.data.reasonId && value.data.reason) {
                this.saveOrSubmitInvestigation(value.data);
            }
        }
        this.displayModalAddHearingOrReason = value.displayModalAddHearingOrReason;
    }

    public saveDisciplinaryAction() {
        const isCheck = this.validateDisciplinary();
        if (isCheck){
            this.loading = true;
            const dto = {
                DisciplinaryId: this.disciplinaryId,
                DisciplinaryActionId: this.disciplinary.DisciplinaryActionId,
                DisciplinaryPeriodId: this.disciplinary.DisciplinaryPeriodId,
                SanctionStartedAt: this.disciplinary.SanctionStartedAt,
            };
            this.disciplinaryService.saveDisciplinaryAction(dto, this.messageService)
                .then(data => {
                    if (!data) {
                        this.loading = false;
                        return;
                    }

                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        this.loading = false;
                        return;
                    }
                    this.homeDisciplinaryComponent.getRidersDisciplinaries(0);
                    this.cancel();
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                    this.loading = false;
                });
        }
    }

    public suspensionUserThirtyDays() {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId
        };
        this.disciplinaryService.suspensionUserThirtyDays(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.homeDisciplinaryComponent.getRidersDisciplinaries(0);
                this.cancel();
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    public saveHearingAndSetStatusPending() {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId,
            HearingReport: this.disciplinary.HearingReport,
            UserExplanation: this.disciplinary.UserExplanation,
            HearingAttachmentReports: this.disciplinary.HearingAttachmentReports
        };
        this.disciplinaryService.saveHearingAndSetStatusPending(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.getDetailDisciplinary();
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    cancel() {
        this.changedShowDisciplinaryInvestigationSideBar(false);
    }

    public handleInputReportClick(id: string): void {
        document.getElementById(id)?.click();
    }
    public handleInvestigationReportChange(event: Event) {
        const target = event.target as HTMLInputElement;
        console.log(target.files);

        if (!target.files || target.files.length === 0) {
            return;
        }
        else {
            const imageFiles: any = []; // Массив для хранения base64 изображений

            for (const file of Array.from(target.files)) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    if (e?.target?.result) {
                        // Base64 string e.target.result.toString()
                        imageFiles.push({
                            ContentType: file.type,
                            FileName: file.name,
                            FileBase64: e.target.result.toString()
                        });
                    }
                };

                reader.readAsDataURL(file);
            }

            // Проверяем, добавились ли все изображения в массив
            if (target?.files?.length) {
                this.disciplinary.InvestigationAttachmentReports = imageFiles;
            }
        }
    }

    public handleHearingReportChange(event: Event) {
        const target = event.target as HTMLInputElement;

        if (!target.files || target.files.length === 0) {
            return;
        }
        else {
            const imageFiles: any = []; // Массив для хранения base64 изображений

            for (const file of Array.from(target.files)) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    if (e?.target?.result) {
                        // Base64 string e.target.result.toString()
                        imageFiles.push({
                            ContentType: file.type,
                            FileName: file.name,
                            FileBase64: e.target.result.toString()
                        });
                    }
                };
                reader.readAsDataURL(file);
            }

            // Проверяем, добавились ли все изображения в массив
            if (target?.files?.length) {
                this.disciplinary.HearingAttachmentReports = imageFiles;
            }
        }
    }
    private validateDisciplinary(): boolean {
        const requiredFields: { field: any; message: string }[] = [];

        switch (this.disciplinary.DisciplinaryActionId) {
            case this.disciplinaryActionEnum.Closed:
                return true;
            case this.disciplinaryActionEnum.Suspension:
                requiredFields.push({ field: this.disciplinary.DisciplinaryPeriodId, message: 'Period is a required field' });
                requiredFields.push({ field: this.disciplinary.SanctionStartedAt, message: 'Start Sanction is a required field' });
                break;
            case this.disciplinaryActionEnum.Ban:
                requiredFields.push({ field: this.disciplinary.SanctionStartedAt, message: 'Start Sanction is a required field' });
                break;
            case this.disciplinaryActionEnum.TemporarySuspended:
                this.messageService.add({ severity: 'error', summary: 'Error',
                    detail: 'Select a different status for the Investigation Recommendation field' });
                return false;
            default:
                return false;
        }

        for (const { field, message } of requiredFields) {
            if (!field) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
                return false;
            }
        }

        return true;
    }
}
